export default {
      id: "project-type-ingest-usage",
      viewBox: "0 0 16 16",
      url: "assets/" + "sprite.svg#project-type-ingest-usage",
      toString: function () {
        return this.url;
      }
    }